export default "__VITE_ASSET__Fw79WSxc__"